module.exports = __webpack_public_path__ + "static/gustavo-lugo-03d430376170596de9769c8ec9583924.png";